import React from 'react';

export function Typography({ variant = 'p', children, className = '', ...props }) {
  const Component = variant.startsWith('h') ? variant : 'p';
  
  const baseStyles = {
    h1: 'text-4xl md:text-5xl font-bold tracking-tight',
    h2: 'text-3xl md:text-4xl font-semibold tracking-tight',
    h3: 'text-2xl md:text-3xl font-semibold tracking-tight',
    h4: 'text-xl md:text-2xl font-semibold tracking-tight',
    p: 'text-base leading-7',
    small: 'text-sm font-medium leading-none',
    muted: 'text-sm text-gray-500 dark:text-gray-400',
  };

  const variantClass = baseStyles[variant] || baseStyles.p;

  return (
    <Component className={`${variantClass} ${className}`} {...props}>
      {children}
    </Component>
  );
}
